/* global axios */

import ApiClient from './ApiClient';

class RealEstateCommissionSupportAPI extends ApiClient {
  constructor() {
    super('real_estate_commission_support', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  addressCatalog(params = {}) {
    return axios.get(`${this.url}/address_catalog`, { params });
  }

  managerCatalog() {
    return axios.get(`${this.url}/manager_catalog`);
  }
}

export default new RealEstateCommissionSupportAPI();
